import {
  Divider, List,
} from '@mui/material';
import SpeedIcon from '@mui/icons-material/Speed';
import NatureIcon from '@mui/icons-material/Nature';
import RouteIcon from '@mui/icons-material/Route';
import HistoryIcon from '@mui/icons-material/History';
import PersonIcon from '@mui/icons-material/Person';
import { useLocation } from 'react-router-dom';
import { useTranslation } from '../common/components/LocalizationProvider';
import MenuItem from '../common/components/MenuItem';

const ManagementMenu = () => {
  const t = useTranslation();
  const location = useLocation();

  return (
    <>
      <List>
        <MenuItem
          title={t('reportSpeeding')}
          link="/reports/management/speeding"
          icon={<SpeedIcon />}
          selected={location.pathname === '/reports/management/speeding'}
        />
        <MenuItem
          title={t('reportEcoDriving')}
          link="/reports/management/eco"
          icon={<NatureIcon />}
          selected={location.pathname === '/reports/management/eco'}
        />
        <MenuItem
          title={t('reportTripsAnalysis')}
          link="/reports/management/trips"
          icon={<RouteIcon />}
          selected={location.pathname === '/reports/management/trips'}
        />
        <Divider />
        <MenuItem
          title={t('reportPositionsHistory')}
          link="/reports/management/positions"
          icon={<HistoryIcon />}
          selected={location.pathname === '/reports/management/positions'}
        />
        <MenuItem
          title={t('reportDriverPerformance')}
          link="/reports/management/driver"
          icon={<PersonIcon />}
          selected={location.pathname === '/reports/management/driver'}
        />
      </List>
    </>
  );
};

export default ManagementMenu;
